import type { PersonCard as PersonCardProps } from '@/types';
import { PersonCardLinks } from './person-card';

// The /id/:slug card of a hack-26 edition: same card, with the edition's logo and city
// above it and no font-title on the labels
// (src/features/person-id/hack-26-person-card.tsx).
export function Hack26PersonProfilePage({
  person,
  city,
}: {
  person: PersonCardProps;
  city: string;
}) {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="mx-auto w-full max-w-md">
          <Hack26PersonCard person={person} city={city} />
        </div>
      </div>
    </div>
  );
}

function Hack26PersonCard({
  person,
  city,
}: {
  person: PersonCardProps;
  city: string;
}) {
  return (
    <div className="border-2 border-primary bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-2 border-primary/20 border-b px-6 pt-6 pb-3">
        <div
          role="img"
          aria-label="Platanus Hack 26"
          className="w-44 bg-primary"
          style={{
            aspectRatio: '420 / 76',
            maskImage: 'url(/hack-26/credentials/logo-hack-26-white.svg)',
            maskRepeat: 'no-repeat',
            maskPosition: 'center',
            maskSize: 'contain',
            WebkitMaskImage: 'url(/hack-26/credentials/logo-hack-26-white.svg)',
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            WebkitMaskSize: 'contain',
          }}
        />
        <span className="text-center font-mono text-primary text-sm tracking-[0.2em]">
          {city}
        </span>
      </div>

      <div className="flex flex-col items-center gap-4 p-6 sm:p-8">
        {person.avatarUrl && (
          <div className="relative h-24 w-24 overflow-hidden border-2 border-primary sm:h-32 sm:w-32">
            <img
              src={person.avatarUrl}
              alt={person.fullName}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        )}

        <div className="text-center">
          <span className="inline-block bg-primary px-3 py-1 font-bold text-background text-xs tracking-wider sm:text-sm">
            {person.title}
          </span>
        </div>

        <div className="text-center">
          <h1 className="font-bold text-2xl text-primary sm:text-3xl">
            {person.fullName}
          </h1>
          {person.githubUsername && (
            <p className="mt-1 font-mono text-primary/70 text-sm sm:text-base">
              @{person.githubUsername}
            </p>
          )}
        </div>

        {person.subtitle && (
          <p className="text-center font-mono text-primary/70 text-sm">
            {person.subtitle}
          </p>
        )}
      </div>

      <PersonCardLinks person={person} />
    </div>
  );
}
